function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
import TextTrackCueList from './text-track-cue-list';
import * as Fn from '@emav-util/fn.js';
import {
    TextTrackKind,
    TextTrackMode
} from './track-enums';
import log from '@emav-util/log.js';
import window from 'global/window';
import Track from './track.js';
import { isCrossOrigin } from '@emav-util/url.js';
import XHR from 'xhr';
import merge from '@emav-util/merge-options';
var parseCues = function parseCues(srcContent, track) {
    var parser = new window.WebVTT.Parser(window, window.vttjs, window.WebVTT.StringDecoder());
    var errors = [];
    parser.oncue = function (cue) {
        track.addCue(cue);
    };
    parser.onparsingerror = function (error) {
        errors.push(error);
    };
    parser.onflush = function () {
        track.trigger({
            type: 'loadeddata',
            target: track
        });
    };
    parser.parse(srcContent);
    if (errors.length > 0) {
        if (window.console && window.console.groupCollapsed) {
            window.console.groupCollapsed('Text Track parsing errors for '.concat(track.src));
        }
        errors.forEach(function (error) {
            return log.error(error);
        });
        if (window.console && window.console.groupEnd) {
            window.console.groupEnd();
        }
    }
    parser.flush();
};
var loadTrack = function loadTrack(src, track) {
    var opts = { uri: src };
    var crossOrigin = isCrossOrigin(src);
    if (crossOrigin) {
        opts.cors = crossOrigin;
    }
    XHR(opts, Fn.bind(this, function (err, response, responseBody) {
        if (err) {
            return log.error(err, response);
        }
        track.loaded_ = true;
        if (typeof window.WebVTT !== 'function') {
            if (track.tech_) {
                var loadHandler = function loadHandler() {
                    return parseCues(responseBody, track);
                };
                track.tech_.on('vttjsloaded', loadHandler);
                track.tech_.on('vttjserror', function () {
                    log.error('vttjs failed to load, stopping trying to process '.concat(track.src));
                    track.tech_.off('vttjsloaded', loadHandler);
                });
            }
        } else {
            parseCues(responseBody, track);
        }
    }));
};
var TextTrack = function (_Track) {
    _inherits(TextTrack, _Track);
    function TextTrack() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, TextTrack);
        if (!options.tech) {
            throw new Error('A tech was not provided.');
        }
        var settings = merge(options, {
            kind: TextTrackKind[options.kind] || 'subtitles',
            language: options.language || options.srclang || ''
        });
        var mode = TextTrackMode[settings.mode] || 'disabled';
        var default_ = settings['default'];
        if (settings.kind === 'metadata' || settings.kind === 'chapters') {
            mode = 'hidden';
        }
        _this = _possibleConstructorReturn(this, _getPrototypeOf(TextTrack).call(this, settings));
        _this.tech_ = settings.tech;
        _this.cues_ = [];
        _this.activeCues_ = [];
        var cues = new TextTrackCueList(_this.cues_);
        var activeCues = new TextTrackCueList(_this.activeCues_);
        var changed = false;
        var timeupdateHandler = Fn.bind(_assertThisInitialized(_this), function () {
            if (changed) {
                this.trigger('cuechange');
                changed = false;
            }
        });
        if (mode !== 'disabled') {
            _this.tech_.ready(function () {
                _this.tech_.on('timeupdate', timeupdateHandler);
            }, true);
        }
        Object.defineProperties(_assertThisInitialized(_this), {
            'default': {
                get: function get() {
                    return default_;
                },
                set: function set() {
                }
            },
            mode: {
                get: function get() {
                    return mode;
                },
                set: function set(newMode) {
                    var _this2 = this;
                    if (!TextTrackMode[newMode]) {
                        return;
                    }
                    mode = newMode;
                    if (mode !== 'disabled') {
                        this.tech_.ready(function () {
                            _this2.tech_.on('timeupdate', timeupdateHandler);
                        }, true);
                    } else {
                        this.tech_.off('timeupdate', timeupdateHandler);
                    }
                    this.trigger('modechange');
                }
            },
            cues: {
                get: function get() {
                    if (!this.loaded_) {
                        return null;
                    }
                    return cues;
                },
                set: function set() {
                }
            },
            activeCues: {
                get: function get() {
                    if (!this.loaded_) {
                        return null;
                    }
                    if (this.cues.length === 0) {
                        return activeCues;
                    }
                    var ct = this.tech_.currentTime();
                    var active = [];
                    for (var i = 0, l = this.cues.length; i < l; i++) {
                        var cue = this.cues[i];
                        if (cue.startTime <= ct && cue.endTime >= ct) {
                            active.push(cue);
                        } else if (cue.startTime === cue.endTime && cue.startTime <= ct && cue.startTime + 0.5 >= ct) {
                            active.push(cue);
                        }
                    }
                    changed = false;
                    if (active.length !== this.activeCues_.length) {
                        changed = true;
                    } else {
                        for (var _i = 0; _i < active.length; _i++) {
                            if (this.activeCues_.indexOf(active[_i]) === -1) {
                                changed = true;
                            }
                        }
                    }
                    this.activeCues_ = active;
                    activeCues.setCues_(this.activeCues_);
                    return activeCues;
                },
                set: function set() {
                }
            }
        });
        if (settings.src) {
            _this.src = settings.src;
            loadTrack(settings.src, _assertThisInitialized(_this));
        } else {
            _this.loaded_ = true;
        }
        return _this;
    }
    _createClass(TextTrack, [
        {
            key: 'addCue',
            value: function addCue(originalCue) {
                var cue = originalCue;
                if (window.vttjs && !(originalCue instanceof window.vttjs.VTTCue)) {
                    cue = new window.vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
                    for (var prop in originalCue) {
                        if (!(prop in cue)) {
                            cue[prop] = originalCue[prop];
                        }
                    }
                    cue.id = originalCue.id;
                    cue.originalCue_ = originalCue;
                }
                var tracks = this.tech_.textTracks();
                for (var i = 0; i < tracks.length; i++) {
                    if (tracks[i] !== this) {
                        tracks[i].removeCue(cue);
                    }
                }
                this.cues_.push(cue);
                this.cues.setCues_(this.cues_);
            }
        },
        {
            key: 'removeCue',
            value: function removeCue(_removeCue) {
                var i = this.cues_.length;
                while (i--) {
                    var cue = this.cues_[i];
                    if (cue === _removeCue || cue.originalCue_ && cue.originalCue_ === _removeCue) {
                        this.cues_.splice(i, 1);
                        this.cues.setCues_(this.cues_);
                        break;
                    }
                }
            }
        }
    ]);
    return TextTrack;
}(Track);
TextTrack.prototype.allowedEvents_ = { cuechange: 'cuechange' };
export default TextTrack;